import crypto from "crypto-js"

const plugin = {
    install: function (Vue) {
        Vue.prototype.$crypto = crypto
        Vue.$crypto = crypto
    }
}

export default plugin